import { render, staticRenderFns } from "./vendor-register.vue?vue&type=template&id=c6cfbe2a&scoped=true&"
import script from "./vendor-register.vue?vue&type=script&lang=js&"
export * from "./vendor-register.vue?vue&type=script&lang=js&"
import style0 from "./vendor-register.vue?vue&type=style&index=0&id=c6cfbe2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6cfbe2a",
  null
  
)

export default component.exports